import React from 'react';
import { getCookie } from 'Jsx/Utils/cookies';

const useCanShowAccessPreview = course => {
  const [canShowAccessPreview, setCanShowAccessPreview] = React.useState(false);

  React.useEffect(() => {
    if (
      course.courseType === 'freemium' &&
      getCookie('__course_access_preview').__course_access_preview === 'True'
    ) {
      setCanShowAccessPreview(true);
    }
  }, []);

  return { canShowAccessPreview };
};

export default useCanShowAccessPreview;
